var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "d-in-block",
      style: { width: _vm.width, height: _vm.height },
    },
    [
      _c(
        _vm.tootipCmpt,
        {
          tag: "component",
          attrs: {
            content: _vm.$t("pc_biz_lbl_joinlib" /** 加入知识库 */),
            placement: "top",
            disabled: _vm.disabled || _vm.noTooltip,
          },
        },
        [
          _vm.$slots.default
            ? _vm._t("default")
            : _c("yxtf-svg", {
                class: [_vm.disabled ? "yxtbiz-joinlib_notallowed" : "hand"],
                attrs: {
                  width: "100%",
                  height: "100%",
                  "remote-url": _vm.svgUrl,
                  "icon-class": "folder-icon",
                },
                nativeOn: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.showDialog.apply(null, arguments)
                  },
                },
              }),
        ],
        2
      ),
      _vm.show
        ? _c("MainDialog", {
            ref: "dialog",
            attrs: {
              scene: _vm.scene,
              "file-id": _vm.fileId,
              "file-name": _vm.fileName,
              "file-size": _vm.fileSize,
              "file-size-type": _vm.fileSizeType,
              "file-ext": _vm.fileExt,
              "storage-type": _vm.storageType,
              link: _vm.link,
              linkName: _vm.linkName,
              intraLink: _vm.intraLink,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }